import styled from 'styled-components'

import { type IFilterTagsProps } from '../FilterTags'
import { TagStyled } from '@ui/elements/Tag/styles/TagStyled'

export const FilterTagsStyled = styled.div<IFilterTagsProps>`
  display: block;
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.label)};

  ${TagStyled} {
    margin-top: ${(props) => props.theme.typography.pxToRem(6)};
    margin-bottom: ${(props) => props.theme.typography.pxToRem(6)};
  }
`
